import type { OrganisationSearchResult } from '~/api/gen'

// Données mock pour GET /organisations (recherche d'offices de la hotline).
//
// `officeMartin` a un listing d'annonces dédié (cf. annoncesDiffusionOfficeMartin) :
// le sélectionner dans le filtre organisation doit recharger la page Diffusion.

/** Office de l'utilisateur mock (cf. msw/mocks/account/organizations.ts). */
export const officeToulouse: OrganisationSearchResult = {
  codeNs: '0000011616',
  nom: 'Office Notarial de Toulouse',
  crpcen: '11616',
}

export const officeMartin: OrganisationSearchResult = {
  codeNs: '0000022727',
  nom: 'Étude Martin & Associés',
  crpcen: '35001',
}

export const officeBordeaux: OrganisationSearchResult = {
  codeNs: '0000033838',
  nom: 'Office Notarial de Bordeaux',
  crpcen: '33012',
}

export const organisations: OrganisationSearchResult[] = [officeToulouse, officeMartin, officeBordeaux]
